import { CustomerApiService, StudentApiService } from "../api";
import * as moment from "moment";
import { cleanObject } from "@agent-ds/shared/util/util";
import * as i0 from "@angular/core";
import * as i1 from "../api/customer-api.service";
import * as i2 from "../api/student-api.service";
// progress-statuses.ts の SEMINAR_TYPE は progress-actions.ts を経由して循環依存が生じるため、ここでローカル定義する
const SEMINAR_TYPE = {
    SEMI_FINAL_INTERVIEW: 99,
    FINAL_INTERVIEW: 100,
};
export var Yomi3Target;
(function (Yomi3Target) {
    Yomi3Target["schedule"] = "yomi3Schedule";
    Yomi3Target["passed"] = "yomi3Passed";
    Yomi3Target["inclination"] = "yomi3Inclination";
})(Yomi3Target || (Yomi3Target = {}));
export var ExpectedCompanyTarget;
(function (ExpectedCompanyTarget) {
    ExpectedCompanyTarget["Company1"] = "p_expected_company_flag";
    ExpectedCompanyTarget["Company2"] = "p_expected_company2_flag";
})(ExpectedCompanyTarget || (ExpectedCompanyTarget = {}));
export class CustomerExpectedCompanyYomiService {
    /**
     * コンストラクタ
     */
    constructor(customerApiService, studentService) {
        this.customerApiService = customerApiService;
        this.studentService = studentService;
    }
    getSalesTargetCustomerListSize(isManager = false) {
        return isManager ? 500 : 200;
    }
    getDefaultSortedCustomerProgressess(customersProgresses) {
        customersProgresses.sort((aP, bP) => {
            const a = aP.student;
            const b = bP.student;
            if (!b.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
                return -1;
            }
            if (a.dynamicData.rank > b.dynamicData.rank) {
                return 1;
            }
            return 0;
        });
        return customersProgresses;
    }
    getDefaultSortedCustomers(customers) {
        customers.sort((a, b) => {
            if (!b.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
                return -1;
            }
            if (a.dynamicData.rank > b.dynamicData.rank) {
                return 1;
            }
            return 0;
        });
        return customers;
    }
    pickTop1StudentSituationMemoWithSortAndFormat(studentSituationMemos) {
        if (studentSituationMemos && studentSituationMemos.length >= 1) {
            studentSituationMemos.sort((a, b) => {
                if (a.registerDate > b.registerDate) {
                    return -1;
                }
                if (a.registerDate < b.registerDate) {
                    return 1;
                }
                return (b.id || 0) - (a.id || 0);
            });
            const situationMemo = studentSituationMemos[0];
            situationMemo.situationMemoData = {
                memo: this.handlerSituationMemoEtcView(situationMemo),
                orderOfPreference: this.handlerSituationMemoWishView(situationMemo),
                nextAction: this.handlerSituationMemoNextView(situationMemo)
            };
            return situationMemo;
        }
        else {
            const situationMemo = {};
            situationMemo.situationMemoData = {};
            return situationMemo;
        }
    }
    handlerSituationMemoWishView(picMemo) {
        if (!picMemo) {
            return '';
        }
        const memo = picMemo.situationMemo;
        const wishMemo = memo.indexOf('志望状況');
        const nextMemo = memo.indexOf('ネクストアクション');
        if (wishMemo !== -1 && nextMemo !== -1) {
            const cut = memo.slice(wishMemo, nextMemo - 3);
            return cut.replace('志望状況', '').trim();
        }
        return '';
    }
    handlerSituationMemoNextView(picMemo) {
        if (!picMemo) {
            return '';
        }
        const memo = picMemo.situationMemo;
        const nextMemo = memo.indexOf('ネクストアクション');
        const etcMemo = memo.indexOf('その他メモ');
        if (nextMemo !== -1 && etcMemo !== -1) {
            const cut = memo.slice(nextMemo, etcMemo - 3);
            return cut.replace('ネクストアクション', '').trim();
        }
        return '';
    }
    handlerSituationMemoEtcView(picMemo) {
        if (!picMemo) {
            return '';
        }
        const memo = picMemo.situationMemo;
        const etcMemo = memo.indexOf('その他メモ');
        if (etcMemo !== -1) {
            const cut = memo.slice(etcMemo);
            return cut.replace('その他メモ', '').trim();
        }
        return '';
    }
    makeCustomersExpectedCompanyUIList(expectedCompanies) {
        const noExpectedCompanyDefaultItem = { label: '-----', value: 0 };
        return [
            noExpectedCompanyDefaultItem,
            ...expectedCompanies.map(d => ({
                label: d.e_name,
                value: d.p_id
            }))
        ];
    }
    fetchMySalesReport(selectedExpectedContractMonthValue) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const expectedContractMonth = moment(selectedExpectedContractMonthValue, 'YYYY-MM');
        const params = {
            contractDateFrom: expectedContractMonth
                .clone()
                .startOf('month')
                .format('YYYY-MM-DD'),
            contractDateTo: expectedContractMonth
                .clone()
                .endOf('month')
                .format('YYYY-MM-DD'),
        };
        return this.customerApiService.getSalesReportOfCurrentUser(params);
    }
    fetchMyMonthlySalesOverview(selectedExpectedContractMonthValue) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const selectedMonth = moment(selectedExpectedContractMonthValue, 'YYYY-MM');
        const year = selectedMonth.clone().startOf('month').format('YYYY');
        const month = selectedMonth.clone().startOf('month').format('MM');
        return this.customerApiService.getMyMonthlySalesOverview(year, month, {});
    }
    fetchTeamSalesReport(teamId, selectedExpectedContractMonthValue) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const expectedContractMonth = moment(selectedExpectedContractMonthValue, 'YYYY-MM');
        const params = {
            contractDateFrom: expectedContractMonth
                .clone()
                .startOf('month')
                .format('YYYY-MM-DD'),
            contractDateTo: expectedContractMonth
                .clone()
                .endOf('month')
                .format('YYYY-MM-DD'),
            teamId: [teamId]
        };
        return this.customerApiService.getSalesReport(params);
    }
    fetchTeamMonthlySalesOverviews(teamId, selectedExpectedContractMonthValue) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const selectedMonth = moment(selectedExpectedContractMonthValue, 'YYYY-MM');
        const year = selectedMonth.clone().startOf('month').format('YYYY');
        const month = selectedMonth.clone().startOf('month').format('MM');
        return this.customerApiService.getTeamMonthlySalesOverviews(teamId, year, month, {});
    }
    fetchMySalesTargetCustomerList(selectedExpectedContractMonthValue, extraParams) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ from: 0, size: 4000, sort: 'registrationStatus', order: 'desc' }, extraParams));
        return this.customerApiService
            .getMySalesTargetCustomerListOfExpectedContractMonth(selectedExpectedContractMonthValue, params);
    }
    fetchTeamSalesTargetCustomerList(teamId, selectedExpectedContractMonthValue, extraParams) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ from: 0, size: 4000, sort: 'registrationStatus', order: 'desc' }, extraParams));
        return this.customerApiService
            .getTeamSalesTargetCustomerListOfExpectedContractMonth(teamId, selectedExpectedContractMonthValue, params);
    }
    fetchMyRaSalesTargetCustomerList(selectedExpectedContractMonthValue, page = 1, pageSize = 50, filterParams = {}) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ from: (page - 1) * pageSize, size: pageSize, sort: 'status', order: 'desc' }, filterParams));
        return this.customerApiService
            .getMyRaSalesTargetCustomerListOfExpectedContractMonth(selectedExpectedContractMonthValue, params);
    }
    fetchMyRaSalesTargetCustomerTotal(selectedExpectedContractMonthValue, filterParams = {}) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ sort: 'status', order: 'desc' }, filterParams));
        return this.customerApiService
            .getMyRaSalesTargetCustomerTotalOfExpectedContractMonth(selectedExpectedContractMonthValue, params);
    }
    fetchTeamRaSalesTargetCustomerList(teamId, selectedExpectedContractMonthValue, page = 1, pageSize = 50, filterParams = {}) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ from: (page - 1) * pageSize, size: pageSize, sort: 'status', order: 'desc' }, filterParams));
        return this.customerApiService
            .getTeamRaSalesTargetCustomerListOfExpectedContractMonth(teamId, selectedExpectedContractMonthValue, params);
    }
    fetchTeamRaSalesTargetCustomerTotal(teamId, selectedExpectedContractMonthValue, filterParams = {}) {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const params = cleanObject(Object.assign({ sort: 'status', order: 'desc' }, filterParams));
        return this.customerApiService
            .getTeamRaSalesTargetCustomerTotalOfExpectedContractMonth(teamId, selectedExpectedContractMonthValue, params);
    }
    isCurrentMonth5WeekTarget() {
        const startOfMonth = moment().startOf('month');
        const endOfMonth = moment().endOf('month');
        const weeksInMonth = endOfMonth.diff(startOfMonth, 'weeks') + 1;
        return weeksInMonth === 5;
    }
    currentWeekTarget() {
        const startOfMonth = moment().startOf('month');
        return moment().diff(startOfMonth, 'weeks') + 1;
    }
    handleSaveMyMonthlySalesOverviewForTargetMonth(selectedExpectedContractMonthValue, salesSummaryForUserModel, salesType = 'ca') {
        if (!this.validMonthValue(selectedExpectedContractMonthValue)) {
            return;
        }
        const year = moment(selectedExpectedContractMonthValue).startOf('month').format('YYYY');
        const month = moment(selectedExpectedContractMonthValue).startOf('month').format('MM');
        const summaryRow = (salesSummaryForUserModel && salesSummaryForUserModel[salesType]) || {};
        return this.customerApiService.updateMyMonthlySalesOverview(year, month, {
            targetGk: summaryRow.gkTarget && Number(summaryRow.gkTarget),
            targetSn: summaryRow.snTarget && Number(summaryRow.snTarget),
            externalRevenue: summaryRow.externalSalesRevenue && Number(summaryRow.externalSalesRevenue),
        });
    }
    handleSaveMemo(studentId, memo, loginUser) {
        const memoData = memo.situationMemoData;
        const memoString = `◾️志望状況\n\n${memoData.orderOfPreference || ''}\n\n◾️ネクストアクション\n\n${memoData.nextAction || ''}\n\n◾️その他メモ\n\n${memoData.memo || ''}`;
        const newMemo = {
            registerDate: moment().format('YYYY-MM-DD'),
            situationMemo: memoString,
            userId: loginUser.id,
        };
        return this.studentService.addMemo(studentId, newMemo);
    }
    handleSaveMgrMemo(studentId, memoString) {
        return this.studentService.updateMgrMemo({
            studentId,
            memoString,
        });
    }
    handleSaveRaMemo(progressId, memoString) {
        return this.customerApiService.updateRaMemo({
            progressId,
            memoString
        });
    }
    handleExpectedSKUpdate(studentId, progressId, expectedSk) {
        if (!progressId) {
            return;
        }
        return this.customerApiService
            .updateExpectedSK(Number(studentId), Number(progressId), expectedSk);
    }
    getYearMonthFromDateString(dateString) {
        if (!dateString) {
            return '';
        }
        if (!moment(dateString, moment.ISO_8601, true).isValid()) {
            return '';
        }
        return moment(dateString).format('YYYY-MM');
    }
    handleUpdateExpectedContractMonth(expectedContractMonth, student) {
        const formattedExpectedContractMonth = this.formatExpectedContractMonth(expectedContractMonth);
        student.dynamicData.expectedContractMonth = formattedExpectedContractMonth;
        return this.customerApiService.updateExpectedContractMonth(student.id, formattedExpectedContractMonth);
    }
    handleUpdateRaExpectedContractMonth(expectedContractMonth, progress) {
        const formattedExpectedContractMonth = this.formatExpectedContractMonth(expectedContractMonth);
        progress.dynamicData.raExpectedContractMonth = formattedExpectedContractMonth;
        return this.customerApiService.updateRaExpectedContractMonth(progress.id, formattedExpectedContractMonth);
    }
    updateCustomerExpectedCompany(studentId, newExpectedCompany, customersExpectedCompanyListMapping) {
        const foundExpectedCompanyByTarget = customersExpectedCompanyListMapping[studentId].find(ec => Number(ec.p_expected_company_flag) === 1);
        const currentProgressId = foundExpectedCompanyByTarget ? foundExpectedCompanyByTarget.p_id : 0;
        return this.customerApiService.updateExpectedCompanyFlag(studentId, currentProgressId, newExpectedCompany);
    }
    updateCustomerExpectedCompany2(studentId, newExpectedCompany, customersExpectedCompanyListMapping) {
        const foundExpectedCompanyByTarget = customersExpectedCompanyListMapping[studentId].find(ec => Number(ec.p_expected_company2_flag) === 1);
        const currentProgressId = foundExpectedCompanyByTarget ? foundExpectedCompanyByTarget.p_id : 0;
        return this.customerApiService.updateExpectedCompany2Flag(studentId, currentProgressId, newExpectedCompany);
    }
    makeYomi3ProbabilityDataFrom(expectedCompanyData) {
        return {
            label: expectedCompanyData.p_yomi_3_probability_label,
            probability: expectedCompanyData.p_yomi_3_probability,
        };
    }
    makeRaYomi3ProbabilityDataFrom(progress) {
        return {
            label: progress.dynamicData.raYomi3ProbabilityResultLabel,
            probability: progress.dynamicData.raYomi3ProbabilityResult,
        };
    }
    callCalculateApiForYomi3Probability(expectedCompanyData) {
        return this.customerApiService.calcYomi3Probability({
            yomi3Passed: expectedCompanyData.p_yomi_3_passed,
            yomi3Inclination: expectedCompanyData.p_yomi_3_inclination,
            yomi3Schedule: expectedCompanyData.p_yomi_3_schedule,
        });
    }
    callCalculateApiForRaYomi3Probability(progress) {
        return this.customerApiService.calcYomi3Probability({
            yomi3Passed: progress.dynamicData.raYomi3Passed,
            yomi3Inclination: progress.dynamicData.raYomi3Inclination,
            yomi3Schedule: progress.dynamicData.raYomi3Schedule,
        });
    }
    handlerYomiTypeChange(studentId, customers) {
        const studentData = customers.find(customer => customer.id === studentId);
        return this.customerApiService.updateYomi(studentId, { yomi: studentData.dynamicData.yomi });
    }
    handlerRaYomiTypeChange(progressId, raYomi) {
        return this.customerApiService.updateRaYomi(progressId, { yomi: raYomi });
    }
    handleYomi3Change({ expectedCompany, studentId, yomi3Target }) {
        if (!expectedCompany || !expectedCompany.p_id) {
            return;
        }
        const yomi3TargetData = {
            [Yomi3Target.passed]: expectedCompany.p_yomi_3_passed,
            [Yomi3Target.inclination]: expectedCompany.p_yomi_3_inclination,
            [Yomi3Target.schedule]: expectedCompany.p_yomi_3_schedule,
        };
        const requestParam = {
            studentId,
            progressId: expectedCompany.p_id,
            yomi3Value: yomi3TargetData[yomi3Target],
        };
        switch (yomi3Target) {
            case Yomi3Target.passed:
                return this.customerApiService.updateYomi3Passed(requestParam);
            case Yomi3Target.inclination:
                return this.customerApiService.updateYomi3Inclination(requestParam);
            case Yomi3Target.schedule:
                return this.customerApiService.updateYomi3Schedule(requestParam);
        }
    }
    handleRaYomi3Change({ progress, yomi3Target }) {
        if (!progress || !progress.id) {
            return;
        }
        const yomi3TargetData = {
            [Yomi3Target.passed]: progress.dynamicData.raYomi3Passed,
            [Yomi3Target.inclination]: progress.dynamicData.raYomi3Inclination,
            [Yomi3Target.schedule]: progress.dynamicData.raYomi3Schedule,
        };
        const requestParam = {
            studentId: progress.studentId,
            progressId: progress.id,
            yomi3Value: yomi3TargetData[yomi3Target],
        };
        switch (yomi3Target) {
            case Yomi3Target.passed:
                return this.customerApiService.updateRaYomi3Passed(requestParam);
            case Yomi3Target.inclination:
                return this.customerApiService.updateRaYomi3Inclination(requestParam);
            case Yomi3Target.schedule:
                return this.customerApiService.updateRaYomi3Schedule(requestParam);
        }
    }
    getEnterpriseNameFromProgress(progress) {
        if (!progress) {
            return '';
        }
        const progressDynamicData = progress.dynamicData || {};
        const progressJob = progress.job || {};
        const enterpriseDepartment = progressJob.enterpriseDepartment || {};
        const jobEnterprise = enterpriseDepartment.enterprise || {};
        const jobEnterpriseDynamicData = jobEnterprise.dynamicData || {};
        const progressEnterprise = progress.enterprise || {};
        return jobEnterpriseDynamicData.name || jobEnterprise.name || progressEnterprise.name || progressDynamicData.enterpriseName || '';
    }
    handlerExpectedCompanyTypeView(type) {
        if (type === 0) {
            return 'AG';
        }
        if (type === 1) {
            return 'PLUS';
        }
        return '';
    }
    handlerProgressStatusView(expectedCompany, PROGRESS_STATUSES) {
        let word = '';
        if (!expectedCompany.p_status || !(expectedCompany.p_status in PROGRESS_STATUSES)) {
            return word;
        }
        if (expectedCompany.p_seminar_type === SEMINAR_TYPE.SEMI_FINAL_INTERVIEW) {
            word = '最終前';
        }
        else if (expectedCompany.p_seminar_type === SEMINAR_TYPE.FINAL_INTERVIEW) {
            word = '最終';
        }
        else if (expectedCompany.p_n) {
            word = `${expectedCompany.p_n}次`;
        }
        word = word + PROGRESS_STATUSES[expectedCompany.p_status].label;
        return word;
    }
    getProgressStatusViewFromProgress(progress, PROGRESS_STATUSES) {
        let word = '';
        if (!progress.status || !(progress.status in PROGRESS_STATUSES)) {
            return word;
        }
        if (progress.seminarType === SEMINAR_TYPE.SEMI_FINAL_INTERVIEW) {
            word = '最終前';
        }
        else if (progress.seminarType === SEMINAR_TYPE.FINAL_INTERVIEW) {
            word = '最終';
        }
        else if (progress.n) {
            word = `${progress.n}次`;
        }
        word = word + PROGRESS_STATUSES[progress.status].label;
        return word;
    }
    handlerGraduateYearView(year) {
        if (!isNaN(year)) {
            const newYear = String(year);
            return newYear.slice(2);
        }
        return year.slice(2);
    }
    handlerDateMonthDayPlusjp(dateData) {
        const newMonthDay = dateData.slice(5, 10);
        return newMonthDay.replace('-', '/');
    }
    openChat(lineId) {
        if (!lineId) {
            return;
        }
        const url = `https://web.onetoone.console.mico-cloud.jp/ja/dRSUyB8vQqmklRCC2t_85A/talks/${lineId}`;
        window.open(url, '_blank');
    }
    doCalculateSalesSummaryForTeam(salesAmount, teamMonthlySalesOverviews) {
        // CA
        const caUserSummaries = {};
        ((salesAmount && salesAmount.ca && salesAmount.ca.users) || []).forEach(salesAmountRow => {
            const userId = salesAmountRow.userId;
            const salesOverViewOfTargetMonth = teamMonthlySalesOverviews &&
                teamMonthlySalesOverviews.users &&
                teamMonthlySalesOverviews.users[userId];
            caUserSummaries[userId] = this.makeSalesSummaryRow(salesAmountRow, salesOverViewOfTargetMonth || null);
        });
        const caTotalSummary = this.makeSalesSummaryRow((salesAmount && salesAmount.ca && salesAmount.ca.total) || null, (teamMonthlySalesOverviews && teamMonthlySalesOverviews.total) || null);
        const rapaUserSummaries = {};
        ((salesAmount && salesAmount.rapa && salesAmount.rapa.users) || []).forEach(salesAmountRow => {
            const userId = salesAmountRow.userId;
            const salesOverViewOfTargetMonth = teamMonthlySalesOverviews &&
                teamMonthlySalesOverviews.users &&
                teamMonthlySalesOverviews.users[userId];
            rapaUserSummaries[userId] = this.makeSalesSummaryRow(salesAmountRow, salesOverViewOfTargetMonth || null);
        });
        const rapaTotalSummary = this.makeSalesSummaryRow((salesAmount && salesAmount.rapa && salesAmount.rapa.total) || null, (teamMonthlySalesOverviews && teamMonthlySalesOverviews.total) || null);
        // 返却オブジェクトを構築
        return {
            ca: { users: caUserSummaries, total: caTotalSummary },
            rapa: { users: rapaUserSummaries, total: rapaTotalSummary },
        };
    }
    doCalculateSalesSummaryForUser(salesAmountForUser, monthlySalesOverview) {
        const { ca: caSalesAmountRow = null, rapa: rapaSalesAmountRow = null } = (salesAmountForUser || {});
        // CA行のサマリーを作成（他区分が増える場合は同様に呼び出し）
        const caSummary = this.makeSalesSummaryRow(caSalesAmountRow, monthlySalesOverview);
        const rapaSummary = this.makeSalesSummaryRow(rapaSalesAmountRow, monthlySalesOverview);
        // 返却オブジェクトを構築
        return {
            ca: caSummary,
            rapa: rapaSummary,
        };
    }
    makeSalesSummaryRow(salseAmountRow, monthlySalesOverview) {
        // 月次サマリ側：プロパティごとにデフォルト値を付ける
        const { targetSn = null, targetGk = null, externalRevenue = null, } = monthlySalesOverview || {};
        // 売上金額側：こちらも同様にデフォルト値を付ける
        const { snFCST = null, skFCST = null, } = salseAmountRow || {}; // 0 もあり得るのでそのまま
        const safe = (v) => (v == null ? 0 : v);
        // SN目標達成率 = SN FCST / SN目標
        const snTargetAchievementRate = targetSn != null ? ((safe(snFCST) / targetSn) * 100) : null;
        // SK目標達成率 = SK FCST / GK目標
        const skTargetAchievementRate = targetGk != null ? ((safe(skFCST) / targetGk) * 100) : null;
        // SK残 = SK FCST - GK目標
        const skGapWithTarget = (skFCST == null || targetGk == null) ? null : (skFCST - targetGk);
        // GK実績 = SK FCST + 外部売上
        const gkActual = (skFCST == null || targetGk == null)
            ? null
            : safe(skFCST) + safe(externalRevenue);
        // GK実績達成率 = GK実績 / GK目標
        const gkActualAchievementRate = (targetGk != null && gkActual != null)
            ? ((gkActual / targetGk) * 100)
            : null;
        // サマリー行を返却（null セーフな値を利用）
        return {
            snTarget: targetSn,
            snTargetAchievementRate,
            gkTarget: targetGk,
            skTargetAchievementRate,
            skGapWithTarget,
            externalSalesRevenue: externalRevenue,
            gkActual,
            gkActualAchievementRate,
        };
    }
    validMonthValue(monthValue) {
        if (!/^\d{4}-\d{2}$/.test(monthValue)) {
            return false;
        }
        return true;
    }
    formatExpectedContractMonth(expectedContractMonth) {
        if (!expectedContractMonth) {
            return null;
        }
        if (!this.validMonthValue(expectedContractMonth)) {
            return null;
        }
        return moment(`${expectedContractMonth}-01`).format('YYYY-MM-DD');
    }
}
CustomerExpectedCompanyYomiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerExpectedCompanyYomiService_Factory() { return new CustomerExpectedCompanyYomiService(i0.ɵɵinject(i1.CustomerApiService), i0.ɵɵinject(i2.StudentApiService)); }, token: CustomerExpectedCompanyYomiService, providedIn: "root" });
